import Vue from "vue";
import VueRouter from "vue-router";

import authMiddleware from "@/app/auth/middleware";

import routes from "./routes";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(authMiddleware);

export default router;
